module.exports = __webpack_public_path__ + "static/media/PIBKG_violet.83aef048.png";